// https://app.growthbook.io/features/pen-7367_v1
export const PEN_7367_FLAG = 'pen-7367_v1'
